/**
 * Classification Badge Component
 * PROJ-042 - Data Classification & Canvas Enhancement
 *
 * Small badge showing classification level with color
 */

import { useDataClassifications } from '@/hooks/useDataClassifications';

interface ClassificationBadgeProps {
  code: string;
}

export function ClassificationBadge({ code }: ClassificationBadgeProps) {
  const { classifications } = useDataClassifications();
  const classification = classifications.find(c => c.code === code);

  if (!classification) return null;

  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium text-white"
      style={{ backgroundColor: classification.colorCode }}
    >
      {classification.level}
    </span>
  );
}
